import { Locales, Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const PARIS_DAY: Series = {
  id: 'paris_day',
  name: { [Locales.EN]: 'Paris, Day', [Locales.FR]: 'Paris, jour' },
  location: LOCATIONS.PARIS,
};

export default PARIS_DAY;
